import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

function PartnersMain() {
    return (

        <Row className="g-4" style={{ justifyContent: 'center', alignItems: 'stretch' }}>
            <Col xs={12} sm={12} md={6} lg={6} xl={6} style={{ display: 'flex' }}>
                <Card className="aboutCard" style={{ width: '100%' }}>
                    <Card.Body className="aboutCardBody" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '200px' }}>
                        <img
                            src={`${process.env.PUBLIC_URL}/images/partner_meden_inmed.png`}
                            alt="Partner - Meden Inmed"
                            style={{
                                width: '100%',
                                height: '110%',
                                objectFit: 'contain',
                                objectPosition: 'center',
                            }}
                        />
                    </Card.Body>
                </Card>
            </Col>
            <Col xs={12} sm={12} md={6} lg={6} xl={6} style={{ display: 'flex' }}>
                <Card className="aboutCard" style={{ width: '100%' }}>
                    <Card.Body className="aboutCardBody" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '200px' }}>
                        <img
                            src={`${process.env.PUBLIC_URL}/images/partner_fundacja_kanvison.png`}
                            alt="Partner - Kanvison Foundation"
                            style={{
                                width: '100%',
                                height: '110%',
                                objectFit: 'contain',
                                objectPosition: 'center',
                            }}
                        />
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}

export default PartnersMain;